import { Button, TextField, Typography, Checkbox, FormControlLabel } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useState } from 'react';

interface INewReceiptSingleRow {
    data?: any[];
    displayManualEntryModal: () => void;
    displayOpenCertModal: () => void;
}

const InputField = ({
    label,
    value,
    setValue,
    disabled = false
}: {
    label: string;
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    disabled?: boolean;
}) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '80px' }}>
        <Typography sx={{ fontSize: '12px', color: 'black', whiteSpace: 'nowrap' }}>{label}</Typography>
        <TextField
            type="text"
            variant="standard"
            size="small"
            value={value}
            onChange={(e) => {
                const newValue = e.target.value;
                if (/^\d*\.?\d*$/.test(newValue)) setValue(newValue);
            }}
            placeholder={label}
            disabled={disabled}
        />
    </Box>
);

const SingleRow: React.FC<INewReceiptSingleRow> = ({ data = [], displayManualEntryModal, displayOpenCertModal }) => {
    const [value1, setValue1] = useState<string>('0');
    const [value2, setValue2] = useState<string>('0');
    const [value3, setValue3] = useState<string>('0');
    const [finalValue, setFinalValue] = useState<string>('0'); // Fourth text field
    const [fifthValue, setFifthValue] = useState<string>('0'); // Fifth text field
    const [isFinalEditable, setIsFinalEditable] = useState(false);

    // Sixth row fields
    const [beforeVAT, setBeforeVAT] = useState<string>('0');
    const [discountPercent, setDiscountPercent] = useState<string>('0');
    const [totalAmount, setTotalAmount] = useState<string>('0');

    const calculateTotal = (val1: string, val2: string, val3: string) => {
        return (parseFloat(val1) || 0) + (parseFloat(val2) || 0) + (parseFloat(val3) || 0);
    };

    const handleCheckboxToggle = () => {
        setIsFinalEditable((prev) => !prev);
        if (!isFinalEditable) setFinalValue(calculateTotal(value1, value2, value3).toString());
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '50px',
                '@media (max-width:375px)': {
                    gap: '25px'
                },
                minHeight: 'calc(100vh - 100px)',
                padding: '20px'
            }}
        >
            {/* By Delivery Certificate */}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography fontSize={'12px'}>מילוי ע״פ תעודת משלוח</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button sx={{ backgroundColor: '#0099cb', color: 'white', marginTop: '10px' }} onClick={() => displayOpenCertModal()}>
                        בחר תעודת משלוח
                    </Button>
                    <InputField label="סה״כ כולל(ש״ח)" value={value1} setValue={setValue1} />
                </Box>
            </Box>

            {/* By Products */}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography fontSize={'12px'}>מילוי ע״פ מוצרים</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button sx={{ backgroundColor: '#34a20a !important', color: 'white', marginTop: '10px', width: '130px' }}>
                        בחר מוצרים
                    </Button>
                    <InputField label="סה״כ כולל(ש״ח)" value={value2} setValue={setValue2} />
                </Box>
            </Box>

            {/* By Certificates */}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography fontSize={'12px'}>מילוי לפי תעודות</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        sx={{ backgroundColor: '#a73ce8 !important', color: 'white', marginTop: '10px', width: '130px' }}
                        onClick={() => displayManualEntryModal()}
                    >
                        מילוי ידני
                    </Button>
                    <InputField label="סה״כ כולל(ש״ח)" value={value3} setValue={setValue3} />
                </Box>
            </Box>

            {/* Final Sum with Checkbox */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <FormControlLabel control={<Checkbox checked={isFinalEditable} onChange={handleCheckboxToggle} />} label="עגל סכום סופי" />
                <InputField
                    label="סה״כ כולל(ש״ח)"
                    value={isFinalEditable ? finalValue : calculateTotal(value1, value2, value3).toString()}
                    setValue={setFinalValue}
                    disabled={!isFinalEditable}
                />
            </Box>

            {/* Fifth Row - Another TextField without Checkbox */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>סה״כ סופי</Typography>
                <InputField label="סה״כ סופי" value={fifthValue} setValue={setFifthValue} />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <InputField label="לפני מעמ" value={beforeVAT} setValue={setBeforeVAT} />
                <InputField label="הנחה(%)" value={discountPercent} setValue={setDiscountPercent} />
                <InputField label="סהכ" value={totalAmount} setValue={setTotalAmount} />
            </Box>
        </Box>
    );
};

export default SingleRow;
